var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"func-customizada-termo-uso"},[_c('TermosDeUsoComponent',{staticClass:"termo-uso-comp",attrs:{"idTermo":_vm.idTermo,"titulo":_vm.titulo,"button-voltar":false,"buttons-footer":true,"esconder-header":false},on:{"aceito":_vm.aceito,"dataAceite":_vm.bypass,"cancelar":_vm.voltar,"voltar":_vm.voltar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }